import {
  SHOW_CONTACT_DETAILS,
  SHOW_CHAT_HEADS,
  SHOW_MESSAGES,
  SET_PAGE,
} from '../constant';

const initialState = {
  conversation: {
    chatHeadActive: true,
    contactDetailsActive: false,
    messagesActive: false,
  },
};

const isRootConversationsPage = (page) =>
  page === '/conversations' || page === '/conversations/';
const isNotOnAConversationsPage = (page) =>
  page.includes('/conversations') === false;

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_CONTACT_DETAILS:
      return {
        ...state,
        conversation: {
          chatHeadActive: false,
          contactDetailsActive: true,
          messagesActive: false,
        },
      };
    case SHOW_CHAT_HEADS:
      return {
        ...state,
        conversation: {
          chatHeadActive: true,
          contactDetailsActive: false,
          messagesActive: false,
        },
      };
    case SHOW_MESSAGES:
      return {
        ...state,
        conversation: {
          chatHeadActive: false,
          contactDetailsActive: false,
          messagesActive: true,
        },
      };
    case SET_PAGE:
      const page = action.payload;
      if (isRootConversationsPage(page) || isNotOnAConversationsPage(page)) {
        return {
          ...state,
          conversation: {
            chatHeadActive: true,
            contactDetailsActive: false,
            messagesActive: false,
          },
        };
      }
      return state;
    default:
      return state;
  }
};

export default uiReducer;
